export function getTallestHeight(elements: HTMLElement[]): number {
  return Math.max(...Array.from(elements).map((el: HTMLElement) => el.offsetHeight));
}
